import { OFFERINGS } from "./constants";
import { Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import Header from "../../../components/Header";

export default function Offerings() {
  return (
    <Box maxWidth={1100} mx="auto" my={12} px={{ xs: 2, sm: 4 }}>
      <Header
        label="Offerings"
        title="We'll make your stay a memorable one"
        desc="Here's what we have to offer our guests"
      />
      <Stack
        spacing={{ xs: 6, sm: 12 }}
        mt={{ xs: 8, sm: 12 }}
        mb={{ xs: 6, sm: 20 }}
      >
        {OFFERINGS.map(({ icon, title, desc, img }, idx) => (
          <Box key={idx}>
            <Grid
              container
              direction={idx % 2 === 1 ? "row-reverse" : "row"}
              columns={{ xs: 6, md: 12 }}
              spacing={{ xs: 3, sm: 6, md: 12 }}
              alignItems="center"
            >
              <Grid item xs={6}>
                <Stack
                  alignItems="start"
                  data-aos="fade-up"
                  data-aos-delaxy={idx * 100}
                >
                  <picture>
                    <source srcSet={`${icon}.webp`} type="image/webp" />
                    <img
                      src={icon + ".png"}
                      height={56}
                      style={{ marginBottom: 12 }}
                      alt=""
                    />
                  </picture>
                  <Typography variant="h3" typography={{ xs: "h4", sm: "h2" }}>
                    {title}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    color="text.secondary"
                    sx={{ mt: 1 }}
                  >
                    {desc}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Box flex={1} data-aos="fade-up" data-aos-delay={idx * 100}>
                  <picture>
                    <source srcSet={`${img}.webp`} type="image/webp" />
                    <img
                      style={{ borderRadius: 32 }}
                      src={img + ".png"}
                      alt="img"
                      width="100%"
                    />
                  </picture>
                </Box>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
